import { render, staticRenderFns } from "./EmergencyContactPage.vue?vue&type=template&id=4d7da812&scoped=true"
import script from "./EmergencyContactPage.vue.js?vue&type=script&lang=js&external"
export * from "./EmergencyContactPage.vue.js?vue&type=script&lang=js&external"
import style0 from "./EmergencyContactPage.vue?vue&type=style&index=0&id=4d7da812&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7da812",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBarNavIcon,VBtn,VCol,VContainer,VRow})
